import type { Template } from "@/types";

export const PO_05_H4_V1: Template[] = [
    {
        id: "po-05-h4v1-01",
        name: "PO 01 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 277, width: 551, height: 361, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 759, y: 228, width: 225, height: 148, rotation: 0, imageRotation: 0 },
            { id: "3", x: 759, y: 384, width: 225, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 759, y: 540, width: 225, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 992, y: 228, width: 315, height: 460, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h4v1-02",
        name: "PO 02 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 208, y: 94, width: 271, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 208, y: 278, width: 271, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 462, width: 271, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 208, y: 646, width: 271, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 792, y: 94, width: 476, height: 728, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h4v1-03",
        name: "PO 03 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 37, y: 232, width: 337, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 37, y: 463, width: 337, height: 223, rotation: 0, imageRotation: 0 },
            { id: "3", x: 382, y: 0, width: 610, height: 916, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1000, y: 232, width: 337, height: 223, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1000, y: 463, width: 337, height: 223, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-04",
        name: "PO 04 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 30, y: 175, width: 632, height: 421, rotation: 0, imageRotation: 0 },
            { id: "2", x: 30, y: 604, width: 206, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 244, y: 604, width: 205, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 457, y: 604, width: 205, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 838, y: 175, width: 386, height: 567, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h4v1-05",
        name: "PO 05 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 197, y: 146, width: 309, height: 204, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 35, y: 357, width: 309, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 351, y: 357, width: 309, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 197, y: 567, width: 309, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 821, y: 146, width: 419, height: 625, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-06",
        name: "PO 06 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 380, width: 231, height: 155, rotation: 0, imageRotation: 0 },
            { id: "2", x: 239, y: 380, width: 231, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 478, y: 146, width: 418, height: 625, rotation: 0, imageRotation: 0 },
            { id: "4", x: 904, y: 380, width: 231, height: 155, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1143, y: 380, width: 231, height: 155, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-07",
        name: "PO 07 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 612, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 756, y: 208, width: 548, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 756, y: 579, width: 178, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 942, y: 579, width: 177, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1127, y: 579, width: 177, height: 129, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-08",
        name: "PO 08 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 84, y: 71, width: 519, height: 774, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 267, width: 284, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 743, y: 462, width: 284, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 267, width: 284, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 462, width: 284, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "po-05-h4v1-09",
        name: "PO 09 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 239, width: 643, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 650, y: 239, width: 421, height: 294, rotation: 0, imageRotation: 0 },
            { id: "3", x: 650, y: 540, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 864, y: 540, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1078, y: 239, width: 295, height: 439, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h4v1-10",
        name: "PO 10 - H4V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h4_v1_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 235, width: 202, height: 140, rotation: 0, imageRotation: 0 },
            { id: "2", x: 209, y: 235, width: 203, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 382, width: 412, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 419, y: 235, width: 653, height: 446, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 235, width: 296, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

];

